import React from 'react';
import LegalLayout, { L } from './LegalLayout';
import { OPERATOR } from '../../legal/operator';

export default function TermsOfServicePage() {
  return (
    <LegalLayout title="Terms of Service">
      <L.P>
        These Terms govern your use of {OPERATOR.productName} (the “Service”). By creating an
        account or otherwise using the Service, you agree to these Terms. If you do not agree,
        please do not use {OPERATOR.productName}.
      </L.P>

      <L.H2>1. Eligibility</L.H2>
      <L.P>
        You must be at least 16 years old to use {OPERATOR.productName}. By signing up you confirm that
        the information you provide is accurate and that you are using the Service for your personal,
        non-commercial benefit.
      </L.P>

      <L.H2>2. Your account</L.H2>
      <L.UL>
        <L.LI>You are responsible for keeping your login credentials confidential.</L.LI>
        <L.LI>You are responsible for everything that happens under your account.</L.LI>
        <L.LI>Notify us at <L.Mail to={OPERATOR.supportEmail} /> if you suspect unauthorized access.</L.LI>
        <L.LI>One person per account. Sharing accounts is not allowed.</L.LI>
      </L.UL>

      <L.H2>3. Tiers and limits</L.H2>
      <L.P>
        {OPERATOR.productName} offers a Free tier and may offer paid tiers in the future. Limits
        (such as the maximum number of portfolios) are shown in your account and may be adjusted by
        us at any time. For paid tiers, separate billing terms will apply at the time of purchase.
      </L.P>

      <L.H2>4. No investment advice — important</L.H2>
      <L.P>
        <strong>{OPERATOR.productName} is an informational tool, not an investment adviser.</strong> Nothing
        shown in the Service is a recommendation to buy, sell, hold or otherwise transact in any
        security or other asset. Prices, dividends, currency rates and fundamentals are pulled from
        third-party sources and may be delayed, incomplete or wrong. You are solely responsible for
        your investment decisions and should consult a qualified professional where appropriate.
      </L.P>

      <L.H2>5. Acceptable use</L.H2>
      <L.P>You agree not to:</L.P>
      <L.UL>
        <L.LI>Reverse-engineer, scrape or attempt to disrupt the Service.</L.LI>
        <L.LI>Use the Service to violate any law or third-party rights.</L.LI>
        <L.LI>Upload malicious content, automate excessive requests or bypass rate limits.</L.LI>
        <L.LI>Resell or redistribute market data obtained through the Service.</L.LI>
      </L.UL>

      <L.H2>6. Intellectual property</L.H2>
      <L.P>
        The Service’s code, design, copy and branding belong to {OPERATOR.productName}. You retain
        ownership of the data you enter (portfolio names, transactions, notes). By using the
        Service, you grant us a limited licence to process that data only as needed to provide the
        Service.
      </L.P>

      <L.H2>7. Service availability</L.H2>
      <L.P>
        We try hard to keep {OPERATOR.productName} fast and reliable, but the Service is provided
        “as-is” without uptime guarantees. We may modify or discontinue features (and, where
        unavoidable, the Service itself) with reasonable notice.
      </L.P>

      <L.H2>8. Termination</L.H2>
      <L.P>
        You can delete your account at any time from the profile settings. We may suspend or
        terminate accounts that violate these Terms, with or without notice if circumstances
        require. On termination, your data will be removed in line with the{' '}
        <L.A href="/privacy">Privacy Policy</L.A>.
      </L.P>

      <L.H2>9. Limitation of liability</L.H2>
      <L.P>
        To the maximum extent permitted by law, {OPERATOR.productName} is not liable for indirect
        or consequential damages, lost profits, or investment losses arising out of your use of (or
        inability to use) the Service. Our total aggregate liability is limited to the amount you
        paid us in the 12 months preceding the claim — which, for Free users, is zero.
      </L.P>

      <L.H2>10. Changes to the Terms</L.H2>
      <L.P>
        We may revise these Terms. Material changes will be announced by email or in-app banner
        before they take effect. Continuing to use the Service after the changes means you accept
        the revised Terms.
      </L.P>

      <L.H2>11. Governing law</L.H2>
      <L.P>
        These Terms are governed by the laws of {OPERATOR.country}. Any disputes will be resolved
        in the competent courts of {OPERATOR.country}, without prejudice to mandatory consumer
        rights in your country of residence.
      </L.P>

      <L.H2>12. Contact</L.H2>
      <L.P>Questions about these Terms? Write to <L.Mail to={OPERATOR.supportEmail} />.</L.P>
    </LegalLayout>
  );
}
